import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { clearState } from '../../localStorage';
import Api from '../../services/api';
import { __ } from '../../utilities';

class Payment extends Component {
  componentDidMount() {
    const { router } = this.props;
    const params = {};
    const rawParams = Api.paramsToObject(this.props.location.search);
    Object.keys(rawParams).map(paramName => {
      params[paramName] = rawParams[paramName];
      return paramName;
    });

    clearState();

    Api.paymentResult(this.props.params.paygate, params)
      .then(response => {
        switch (response.status) {
          case 'OK':
            router.push(
              `/reservation/platba-uspesna?vs=${response.vs}&pass=${
                response.pass
              }`,
            );
            break;
          case 'TOUT':
            router.push(`/reservation/platba-vyprsala`);
            break;
          case 'FAIL':
            router.push(`/reservation/platba-neuspesna`);
            break;
          default:
            router.push(`/reservation/platba-neuspesna`);
        }
      })
      .catch(e => {
        Sentry.captureException(e);
        router.push('/reservation/platba-neuspesna');
      });
  }

  render() {
    return __('Prebieha overovanie platby ...');
  }
}

Payment.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  params: PropTypes.shape({
    paygate: PropTypes.string,
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

Payment.defaultProps = {};

export default Payment;



// WEBPACK FOOTER //
// ./src/containers/Payment/index.js